/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum RecipeStatus {
    NEW = 'new',
    DISPENSED = 'dispensed',
    DECLINED = 'declined',
    CANCELLED = 'cancelled',
}
